const UserModel = {
  id: "number",
  first_name: "string",
  last_name: "string",
}

export default UserModel
